(function ($, Drupal) {

  'use strict';

  Drupal.behaviors.carousel = {
    attach: function (context, settings) {
      // banner slick
      $(once('d_p_carousel','.field--name-field-banerio-elementas', context)).each(function () {
        var cnt = $(this).find('.d-p-carousel-item').length;

        // If there are no elements - do not activate Slick.
        if (cnt <= 1) {
          return;
        }

        var id = $(this).closest('.paragraph').attr('data-id');

        $(this).slick({
          dots: true,
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          swipeToSlide: true,
          touchMove: true,
          autoplay: true,
          autoplaySpeed: 8000,
          pauseOnHover: false,

          responsive: [
            {
              breakpoint: 540,
              settings: {
                arrows: false,
                slidesToShow: 1
              }
            },
            {

              breakpoint: 992,
              settings: {
                arrows: false,
                slidesToShow: 1
              }
            }
          ]
        });
      });
    }
  };
})(jQuery, Drupal);